import { FC } from "react";
import { CropAvatar } from "./CropAvatar";

interface AvatarCropModalProps {
  imageSrc: string;
  onCropDone: (file: File) => void;
  onCancel: () => void;
}

export const AvatarCropModal: FC<AvatarCropModalProps> = ({
  imageSrc,
  onCropDone,
  onCancel,
}) => {
  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <CropAvatar imageSrc={imageSrc} onCropDone={onCropDone} onCancel={onCancel} />
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed" as const,
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalStyle = {
  width: 400,
  height: 400,
  backgroundColor: "#fff",
  borderRadius: 8,
  overflow: "hidden",
  position: "relative" as const,
};